export const openDocsPage = (path = '', title = 'VitalQC Help Centre') => {
  window.open(`/docs${path}`, title, 'width=1280,height=720')
}
